(()=>{
 function init(scene){
  if(scene.dataset.lampFocusReady)return;
  scene.dataset.lampFocusReady='true';
  if(!('IntersectionObserver' in window)){scene.classList.add('is-lit');return;}
  const focusPoint=document.createElement('span');
  focusPoint.setAttribute('aria-hidden','true');
  focusPoint.style.cssText='position:absolute;top:50%;left:50%;width:1px;height:1px;pointer-events:none';
  scene.append(focusPoint);
  const focus=new IntersectionObserver(entries=>{
   if(entries.some(entry=>entry.isIntersecting))scene.classList.add('is-lit');
  },{rootMargin:'-35% 0px -38% 0px',threshold:0});
  const visibility=new IntersectionObserver(entries=>{
   if(!entries[0].isIntersecting)scene.classList.remove('is-lit');
  },{threshold:0});
  visibility.observe(scene);focus.observe(focusPoint);
  scene.lampCleanup=()=>{focus.disconnect();visibility.disconnect();focusPoint.remove();delete scene.dataset.lampFocusReady;};
 }
 document.querySelectorAll('.don-lamp-scene').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.don-lamp-scene').forEach(init));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.don-lamp-scene').forEach(scene=>scene.lampCleanup?.()));
})();
